import React from "react";

const Divider = props => (
  <li
    aria-orientation="horizontal"
    className="neeto-ui-dropdown__popup-divider"
    role="separator"
    {...props}
  />
);

export default Divider;
